// 引入mitt模块儿
import mitt from 'mitt'
// 创建bus实例
const bus=mitt();
//导出bus实例
export default bus;
